<template>
  <div>
    <label v-if="label">
      <StrongText>{{ label }}</StrongText>
    </label>
    <FormElementStyle>
      <textarea 
        :value="value"
        :style="style"
        :placeholder="placeholder"
        @keydown="$emit('keydown', $event.target.value)"
        @input="$emit('input', $event.target.value)"
        >
      </textarea>
    </FormElementStyle>
  </div>
</template>

<script>
import FormElementStyle from '@/components/FormElementStyle'
import StrongText from '@/components/StrongText'
import colors from '@/services/colors'

export default {
  name: 'Textarea',
  props: {
    label: String,
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  components: {
    StrongText,
    FormElementStyle,
  },
  computed: {
    style() {
      return {
        color: colors.blue
      }
    }
  }
}
</script>

<style lang="sass" scoped>

</style>
